import styled from 'styled-components';

export const FinancingProposalFormsWrapper = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 24px;
  background: ${(props) => props.theme.palette.colors.white};
  padding: 24px;
  border-radius: 8px;
`;

export const FormSpacing = styled.div.attrs({})`
  border-bottom: 1px solid ${(props) => props.theme.palette.colors.shadow};
`;

export const HeaderButtonContainer = styled.div.attrs({})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
`;

export const ButtonContainer = styled.div.attrs({})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
`;
